import { render, staticRenderFns } from "./CollectionsSearch.vue?vue&type=template&id=0f6a0b90&"
import script from "./CollectionsSearch.vue?vue&type=script&lang=js&"
export * from "./CollectionsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports